import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { reducer as notificationsReducer } from 'reapop'
import uiReducer from './features/ui/reducer'
import reducerDeleteState from './reducers/reducerDeleteState'
import reducerCustomer from './reducers/reducerCustomer'
import reducerContact from './reducers/reducerContact'
import reducerProfile from './reducers/reducerProfile'
import reducerProduct from './reducers/reducerProduct'
import reducerVersion from './reducers/reducerVersion'
import reducerUser from './reducers/reducerUser'
import reducerDevice from './reducers/reducerDevice'
import reducerLicensetype from './reducers/reducerLicensetype'
import reducerLicense from './reducers/reducerLicense'
import reducerIOTAccessory from './reducers/reducerIOTAccessory'
import reducerIOTRoom from './reducers/reducerIOTRoom'

export default combineReducers({
    form: formReducer,
    notifications: notificationsReducer(),
    ui: uiReducer,
    deleteState: reducerDeleteState.deleteState,

    allCustomer: reducerCustomer.allCustomer,
    customerInfo: reducerCustomer.customerInfo,

    allContact: reducerContact.allContact,
    searchContact: reducerContact.searchContact,
    contactInfo: reducerContact.contactInfo,

    allProfile: reducerProfile.allProfile,
    profileInfo: reducerProfile.profileInfo,

    allProduct: reducerProduct.allProduct,
    productInfo: reducerProduct.productInfo,
    versionProduct: reducerProduct.versionProduct,

    allVersion: reducerVersion.allVersion,
    versionInfo: reducerVersion.versionInfo,

    allUser: reducerUser.allUser,
    userInfo: reducerUser.userInfo,

    allDevice: reducerDevice.allDevice,
    deviceInfo: reducerDevice.deviceInfo,

    allLicensetype: reducerLicensetype.allLicensetype,
    licensetypeInfo: reducerLicensetype.licensetypeInfo,

    allLicense: reducerLicense.allLicense,
    allLicenseDisplay: reducerLicense.allLicenseDisplay,
    allLicenseIOT: reducerLicense.allLicenseIOT,
    licenseInfo: reducerLicense.licenseInfo,

    allIOTAccessory: reducerIOTAccessory.allIOTAccessory,
    IOTAccessoryInfo: reducerIOTAccessory.IOTAccessoryInfo,

    allIOTRoom: reducerIOTRoom.allIOTRoom,
    IOTRoomInfo: reducerIOTRoom.IOTRoomInfo,
})



// WEBPACK FOOTER //
// ./src/reducers.js